module.exports = __webpack_public_path__ + "media/images/lb/888-2f4e2ac3dda4793b7879bbb4917d5c99.svg";